<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminOrder/">Orders</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/orders/">Orders</a></li>
      <li class="breadcrumb-item active" aria-current="page">Split Orders</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="row align-items-center">
        <div class="col-md-6"></div>
        <div class="col-md-6 mt-4 mt-md-0 text-right float-right">
          <a *ngIf="user.role == 'ACCOUNT_OWNER'"  routerLink="/admin/orders" class="text-danger p-2 ml-2 shift-discard"><b>Discard</b></a>
          <a *ngIf="user.role == 'ROLE_ADMIN'" routerLink="/admin/adminOrder" class="text-danger p-2 ml-2 shift-discard"><b>Discard</b></a>
<!--          <a *ngIf="user.role !== 'ROLE_ADMIN'" class="text-info p-2 ml-2 shift-finish" (click) ="draftOrder()"><b>Finish Later</b></a>-->
          <button class="btn btn-orange text-white p-2 ml-2 shift-receiving"  *ngIf="step === 4" (click) = "submitEditOrder()"><b>Submit</b></button>
        </div>
      </div>
    </div>
  </div>
  <form [hidden]="step !== 1">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2>Recipient Information</h2>
          <div class="row mt-3">
            <div class="col-lg-4 col-sm-6 required">
              <div class="form-group mb-2">
                <label class="mb-1 control-label">Contact</label>
                <ng-select id="contactName" [(ngModel)]="contact" (change)="getContactAddress()"
                           [ngModelOptions]="{standalone: true}" required
                           [items]="contacts"
                           bindLabel="contactName"
                           placeholder="Search for a Customer"
                           [searchFn]="customSearchFn" disabled
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{item?.contactName}} <br/>
                    <small>{{item?.companyName}}</small>
                  </ng-template>
                </ng-select>

              </div>
              <label>Address :<span class="ml-1">{{contactAddressText}}</span></label>
            </div>
            <div class="col-lg-4 offset-lg-4 col-sm-6 required">
              <div class="form-group mb-2">
                <label class="mb-1 control-label">Warehouse</label>
                <ng-select id="warehouseName" [(ngModel)]="warehouse" [ngModelOptions]="{standalone: true}"
                           (change)="getWarehouseAddress()"
                           (click)="getProductsList()" required
                           [items]="warehouses"
                           bindLabel="name" disabled
                           placeholder="Warehouse Name">
                </ng-select>

              </div>
              <label>Address :<span class="ml-1">{{warehouseAddressText}}</span></label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 mb-3 text-danger fw-500" *ngIf="statusText1 || statusText2 || statusText3 || statusText4 || statusText5">Please Enter Mandatory Fields</div>

      <div class="col">
        <ul class="list-inline tab-list">
          <li class="list-inline-item"><a class="list-inline-item" (click)=" tabChange('selectedProducts');" [ngClass]="{'active': tabClicked === 'selectedProducts'}">Selected Products
            <span class="dot bg-danger ml-2" *ngIf="statusText3 || statusText4"></span></a></li>
          <li class="list-inline-item"><a class="nav-link warehouses" (click)=" tabChange('shippingOptions');" [ngClass]="{'active': tabClicked === 'shippingOptions'}">Shipping Options
            <span class="dot bg-danger ml-2" *ngIf="statusText5"></span></a></li>
        </ul>
        <div class="inner-box">
          <div class="row" *ngIf="tabClicked == 'selectedProducts'">
            <div class="col">
              <h2 class="color-3 text-capitalize mt-2 mb-3">Add Products</h2>
              <div class="table-3">
                <table class="table  packing-table-2">
                  <thead class="thead-light">
                  <tr>
                    <th class="pl-0" style="width:400px !important;">Product Name</th>
                    <th style="width:200px !important;">SKU</th>
                    <th style="width:250px !important;">Quantity</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let ol of orderLines">
                    <td style="width:400px !important;">{{ol.productName|titlecase}}</td>
                    <td style="width:200px !important;" class="text-black mb-3">{{ol.sku|uppercase}}<img src="/./assets/images/tick.svg" class="float-right" title="Quantity is less than {{ol.previousQty}}" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="showQtyCheckIcon(ol)"> <img src="/./assets/images/close.svg" class="float-right" title="Quantity should be less than {{ol.previousQty}} and greater than 0" style="width: 1.2em; margin-right:0.5em; margin-top:0.2em;" *ngIf="!showQtyCheckIcon(ol) && ol.previousQty !=1 && ol.quantity != ol.previousQty"></td>
                    <td style="width:250px !important;"><input type="text" id="quantity" [(ngModel)]="ol.quantity" [ngModelOptions]="{standalone: true}" class="form-control" required [disabled]="ol.previousQty==1 && ol.quantity == ol.previousQty" appOnlyNumbers></td>
                    <td><a (click)="removeProduct(ol)" *ngIf="order?.lines?.length !== 1">
                      <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                        <defs><style>.a{fill:#848484;}</style></defs>
                        <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                      </svg> Delete
                    </a></td>
                  </tr>
                  <tr *ngIf="order?.lines?.length !== orderLines?.length">
                    <td style="width:400px !important;">
                      <ng-select id="product" [(ngModel)]="activeProduct" [ngModelOptions]="{standalone: true}"
                                 required (open)="open()"
                                 [items]="selectedProducts"
                                 bindLabel="productName"
                                 placeholder="Search for Product">
                      </ng-select>
                    </td>
                    <td style="width:200px !important;"></td>
                    <td style="width:250px !important;"><input type="text" id="quantity2" [(ngModel)]="quantity" [ngModelOptions]="{standalone: true}" class="form-control" required></td>
                    <td>
                      <a (click)="selectProductForEditOrder()"  >
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                          <defs><style>.ab{fill:#ee7125;}</style></defs>
                          <path class="ab" d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z" transform="translate(-3.375 -3.375)"/>
                        </svg> Add Product
                      </a>
                    </td>
                    <td></td>
                  </tr>
                  </tbody>
                </table>
                <hr>
              </div>
            </div>
          </div>
          <div class="mt-4" *ngIf="tabClicked == 'shippingOptions'">
            <div class="row">
              <div class="col-md-12  dip-in">
                <div class="form-radio mr-5">
                  <input type="radio" id="shift" [(ngModel)]="order.shippingOption" [ngModelOptions]="{standalone: true}"  required value="SHIFT">
                  <label for="shift">Shift</label>
                </div><br><br>
                <div class="form-radio">
                  <input type="radio" id="Regular" [(ngModel)]="order.shippingOption" [ngModelOptions]="{standalone: true}"  required value="THIRD_PARTY">
                  <label for="Regular">Third Party Carriers
                    <p class="label-para-size">(Shift will chose the cheapest and fastest carrier)</p>
                  </label>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="control-label">Shipping Instructions</label>
                  <textarea  id="description" class="form-control" rows="6" [(ngModel)]="order.deliveryInstructions" class="form-control" [ngModelOptions]="{standalone: true}"  required></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <form  [hidden]="step !== 4">
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <div class="row">
            <div class="col">
              <div class="text-center">
                <h2 class="text-black mb-3 review">Review and Confirm</h2>
              </div>
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-md-6">
                      <h2 class="text-black mb-2 review">Contact Details</h2>
                      <label class="text-black"><b>Contact Name :</b><span class="ml-1">{{order?.accountOwnerCustomerName}}</span></label><br>
                      <label class="text-black"><b>Contact Address :</b><span class="ml-1">{{contact?.addressText}}</span></label>
                    </div>
                  </div>
                  <hr class="row-bordered">
                  <div class="row">
                    <div class="col-md-6">
                      <h2 class="text-black mb-2 review">Warehouse Details</h2>
                      <label class="text-black mb-3"><b>Warehouse :</b><span class="ml-1">{{order?.sourceWarehouseName}}</span></label><br>
                      <label class="text-black"><b>Warehouse Address :</b><span class="ml-1">{{warehouse?.addressText}}</span></label>
                    </div>
                  </div>
                  <hr class="row-bordered">
                  <div class="row mt-3">
                    <div class="col-md-8">
                      <h2 class="text-black ml-1 mb-2">Selected Products</h2>
                      <table class="table table-stripe">
                        <thead>
                        <tr>
                          <th>SKU</th>
                          <th>Product Name</th>
                          <th>Quantity</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let sl of orderLines">
                          <td>{{sl.sku|uppercase}}</td>
                          <td>{{sl.productName|titlecase}}</td>
                          <td>{{sl.quantity}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr class="row-bordered">
                  <div class="row">
                    <div class="col-md-6">
                      <h2 class="text-black mb-2 review">Shipping Details</h2>
                      <label class="text-black mb-2"><b>Shipping Option :</b> <span class="ml-1">{{(order.shippingOption == 'THIRD_PARTY' ? 'Third Party' :
                                                                                                   (order.shippingOption == 'SHIFT' ? 'Shift' : ""))}}</span></label><br>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="text-black mb-2"><b>Shipping Instructions : </b><span class="ml-1">{{order.deliveryInstructions}}</span></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form><br><br>
</section>
<div class="form-btn-section"  [hidden]="step != 1">
  <div class="row">
    <div class="col-12 text-right">
     <!-- <button type="reset" (click)="clearFields()" class="btn btn-cancel">Clear</button>-->
      <button type="submit" (click)="reviewAndConfirm()" class="btn btn-orange ml-1">Next</button>
    </div>
  </div>
</div>

<div class="form-btn-section"  [hidden]="step != 4">
  <div class="row">
    <div class="col-6 text-left">
      <button type="button" (click)="selectShippingInformation()" class="btn btn-cancel">Back</button>
    </div>
  </div>
</div>
